module.exports = __webpack_public_path__ + "static/media/sibsLogo.a914b620.ico";